///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//

const { preventDefault } = require("@fullcalendar/core");

///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.dashboard = abcsetup.dashboard || {};
abcsetup.dashboard.rx_vendor = abcsetup.dashboard.rx_vendor || {};

abcsetup.dashboard.rx_vendor.rx = abcsetup.dashboard.rx_vendor.rx || {};
abcsetup.dashboard.rx_vendor.prdocs = abcsetup.dashboard.rx_vendor.prdocs || {};
abcsetup.dashboard.rx_vendor.item_maintenance = abcsetup.dashboard.rx_vendor.item_maintenance || {};
abcsetup.dashboard.rx_vendor.frontstore = abcsetup.dashboard.rx_vendor.frontstore || {};
abcsetup.dashboard.rx_vendor.rfq = abcsetup.dashboard.rx_vendor.rfq || {};



///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.dashboard.rx_vendor = {
    init: function() {
        // Outstanding items delete button clicked
        $(document).on('click', '#outstanding_panel .btn-delete-workflow', function () {
            var _this = $(this);

            if (_this.data('initial_class') == 'field_team' && abcsetup.userRole.class == 'rx_vendor') {
                // Vendor needs to provide a reason for Deleting this Workflow
                abcsetup.alerts.prompt('Delete Workflow Task', 'Please provide a reason for deleting this Workflow Task?', function (resp) {
                    if (resp[0]) {
                        abcsetup.dashboard.rx_vendor.rx.deleteWorkflow(_this.data('id'), resp[1]);
                    }
                }, true);
            } else {
                abcsetup.alerts.confirm('Delete Workflow Task', 'Are you sure you want to delete this workflow task?', function (resp) {
                    if (resp) {
                        abcsetup.dashboard.rx_vendor.rx.deleteWorkflow(_this.data('id'));
                    }
                });
            }
        });

        // pr_docs Decline event handlers
        $(document).on('click', '.dropdown-menu.pr_doc_request_decline', function(event) {
            event.stopPropagation();
        });

        $(document).on('click', 'button.pr_doc_request_decline', function () {
            abcsetup.dashboard.rx_vendor.prdocs.decline(this);
        });

        // pr_docs Decline event handlers
        $(document).on('click', '.dropdown-menu.pr_doc_reminder_update', function(event) {
            // prevent datatable row from being toggled
            event.stopPropagation();
        });

        $(document).on('click', 'button.pr_doc_reminder_update', function () {
            abcsetup.dashboard.rx_vendor.prdocs.update(this);
        });

        // pr_doc reminder Other reason event handler
        $(document).on('click', "input[name='pr_doc_reminder_decline_reasons[]'][value='Other:']", function(event) {
            $(this).siblings(".pr_doc_reminder_decline_reason_other_comment").toggle().val("");
        });

        $(document).on('click', '.decline-all', function() {
            console.log('clicked');
            // popup containing all the pr doc requests
            // with checkboxes
            axios.get('/api/pr_docs/decline/all').then(response => {
                $(response.data).modal('show');
            }).catch(error => {
                alert('Error booting decline all modal.');
            });
        });

        // PR Doc decline all
        $(document).on('click','#pr_doc_decline_all-modal .btn.pr_doc_request_decline-all', function(){
            // popup containing all the pr doc requests
            // with checkboxes
            var checked_reasons = $("#decline-all-pr-docs").find('input[name="pr_doc_reminder_decline_reasons[]"]:checked');
            if (checked_reasons.length == 0) {
                abcsetup.alerts.show('Decline Error', 'Please select at least 1 reason to decline the request');
                return false;
            }
            if ($("#decline-all-pr-docs").find("input[name='pr_doc_reminder_decline_reasons[]'][value='Other:']").is(":checked")) {
                if (!$("#decline-all-pr-docs").find(".pr_doc_reminder_decline_reason_other_comment").val()) {
                    abcsetup.alerts.show('Decline Error', 'Please enter the other reason comment');
                    return false;
                }
            }

            axios.put('/api/pr_docs/decline/all', $('#decline-all-pr-docs').serialize()).then(response => {
                // remove the modal
                $('#pr_doc_decline_all-modal .close').trigger('click');
                $('#pr_doc_decline_all-modal').remove();
                $('.modal-backdrop').remove();
                // show the response text
                abcsetup.alerts.flashMessage(response.data);
                // refresh the pr doc table
                $('#app_data_tables_pr_docs_outstanding_data_table').DataTable().ajax.reload();
            }).catch(error => {
            });
        });

        // Delete button clicked
        $(document).on('click', '#app_data_tables_rx_item_item_data_tablein_process_wrapper .btn-delete', function () {
            var _this = $(this);

            abcsetup.alerts.confirm('Delete Item', 'Are you sure you want to delete this item?', function (resp) {
                if (resp) {
                    abcsetup.dashboard.rx_vendor.rx.delete(_this.data('id'));
                }
            });
        });

        // Non-Rx delete button clicked
        $(document).on('click', '#app_data_tables_front_store_item_item_data_tablein_process_wrapper .btn-delete', function () {
            var _this = $(this);

            abcsetup.alerts.confirm('Delete Item', 'Are you sure you want to delete this item?', function (resp) {
                if (resp) {
                    abcsetup.dashboard.rx_vendor.frontstore.delete(_this.data('id'));
                }
            });
        });

        // Cancel Maintenance button clicked
        $(document).on('click', '#app_data_tables_rx_item_maintenance_item_data_tablein_process_wrapper .btn-cancel', function () {
            var _this = $(this);

            abcsetup.alerts.confirm('Cancel Maintenance', 'Are you sure you want to cancel maintenance on this item?', function (resp) {
                if (resp) {
                    abcsetup.dashboard.rx_vendor.item_maintenance.delete(_this.data('id'),_this.data('type'));
                }
            });
        });

        // RFQ Event delete button clicked
        $(document).on('click', '#rfq_panel .btn-delete', function () {
            var _this = $(this);

            abcsetup.alerts.confirm('Delete RFQ Bid', 'Are you sure you want to delete this RFQ bid?', function (resp) {
                if (resp) {
                    abcsetup.dashboard.rx_vendor.rfq.deleteEvent(_this.data('id'));
                }
            });

            return false;
        });

        // RFQ Event delete button clicked
        $(document).on('click', '#rfq_panel .btn-retract', function () {
            var _this = $(this);

            abcsetup.alerts.confirm('Retract RFQ Bid', 'Are you sure you want to retract this RFQ bid?', function (resp) {
                if (resp) {
                    abcsetup.dashboard.rx_vendor.rfq.retractEvent(_this.data('id'));
                }
            });

            return false;
        });

        // RFQ Event delete button clicked
        $(document).on('click', '#rfq_panel .btn-extend', function () {
            var _this = $(this);

            abcsetup.alerts.prompt('Request an Extension', 'Please specify how many days to extend the bid by:', function (resp) {
                if (resp[0] == true) {
                    abcsetup.dashboard.rx_vendor.rfq.extendEvent(_this.data('id'), resp[1]);
                }
            }, true, true);

            return false;
        });

        // Replenishment Request Anchor Button in Outstanding Tasks Panel Clicked
        $(document).on('click', '#replenishment-anchor', function() {
            $('html, body').scrollTop($("#replenishment_panel").offset().top - 100);
        });

        // Init the RFQ comments lib
        abcsetup.rfq.comments.init();


        /* Short Dated Opt Out - ABCS-4821 */
        $(document).on('click', '.opt-out-btn-js', function(e) {
            let _this = $(this);

            abcsetup.alerts.confirm(
                'Opt Out of Oppertunity',
                `Are you sure that you want to opt out of this short dated opportunity? By opting out, you confirm that you have no expired items to offer.`,
                function(resp) {
                    if (resp) {
                        abcsetup.blockUI(true);

                        axios.post('/api/short_dated_oppertunity/supplier_opt_out', {
                            id: _this.data('id'),
                            org_id: _this.data('org_id')
                        })
                        .then(response => {
                            const data = response.data;

                            if (data && data.success) {
                                abcsetup.alerts.show('Success', data.message);
                                window.LaravelDataTables['short-dated-opportunities-vendor-table'].ajax.reload();
                            }

                            abcsetup.unblockUI();
                        })
                        .catch(error => {
                            console.error(error);
                            abcsetup.alerts.show('Error', 'An error occurred while processing your request. Please try again later and reach out to support if the issue persists.');
                            abcsetup.unblockUI();
                        });
                    }
                }
            );
        })
    },

    /**
     * Yajra datatables have been init - this is the event
     */
    tableDrawCallback: function(table) {
        abcsetup.rfq.common.tableDrawCallback(table);

        // Kind of hacky, but we need to update the badge count for the fake replenishment requests bhoechi button in the outstanding tasks table (used as an anchor)
        var replenishment_task_count = $('#app_data_tables_replenishment_operations_replenishment_tasks_data_table').attr('data-total-records');

            if (replenishment_task_count > 0) {
                $('.replenishment-badge').html('&nbsp' + replenishment_task_count + '&nbsp');
            }
    },




    ///////////////////////////////////////////////////////////////////////////////////////////////////
    //
    //  Rx Methods
    //
    ///////////////////////////////////////////////////////////////////////////////////////////////////
    rx: {
        /**
         *
         */
        deleteWorkflow: function(id, reasonText = '') {
            abcsetup.dashboard.showLoading($('#outstanding_panel'));
            $('#outstanding_panel').find('.dataTables_wrapper').hide();

            axios.delete('/api/workflow_task/' + id, {data: {reason: reasonText}}).then(response => {
                window.location.reload();

            });
        },


        /**
         *
         */
        delete: function(id) {
            abcsetup.dashboard.showLoading($('#new_items_panel'));
            $('#new_items_panel').find('.dataTables_wrapper').hide();

            axios.delete('/rx_item/' + id).then(response => {
                window.location.reload();
            });
        },
    },






    ///////////////////////////////////////////////////////////////////////////////////////////////////
    //
    //  PR Doc Methods
    //
    ///////////////////////////////////////////////////////////////////////////////////////////////////
    prdocs: {
        /**
         * Call ajax /api/pr_docs/decline
         * @param {Object} e - Decline button element clicked
         */
        decline: function(e) {
            var _e = $(e);
            var dropdown = _e.closest('.dropdown-menu.pr_doc_request_decline');
            var pr_doc_reminder = _e.data('pr_doc_reminder')
            var checked_reasons = dropdown.find('input:checkbox:checked');

            if (checked_reasons.length == 0) {
                abcsetup.alerts.show('Decline Error', 'Please select at least 1 reason to decline the request');
                return false;
            }

            if (dropdown.find("input[name='pr_doc_reminder_decline_reasons[]'][value='Other:']").is(":checked")) {
                if (!dropdown.find(".pr_doc_reminder_decline_reason_other_comment").val()) {
                   abcsetup.alerts.show('Decline Error', 'Please enter the other reason comment');
                   return false;
                }
            }

            axios.put('/api/pr_docs/decline/' + pr_doc_reminder,dropdown.find("form").serialize()).then(response => {
                console.log(JSON.stringify(response.data,{},4));
                $(dropdown).dropdown('toggle');
                // NOTE:  we *could* have done a tr.hide() for the row containing the declined record,
                // but we rather want to refresh the datatable. However, we can only do this by calling
                // prdocs.outstanding() as there is no ajax attribute associated with the datatable
                // object which would otherwise have allowed us to call
                // abcsetup.dashboard.rx_vendor.prdocs.datatable.ajax.reload() - hence, this forces
                // a reload of the entire #pr_doc_items element
                window.location.reload();
            });
        },
        /**
         * Call ajax /api/pr_docs/update
         * @param {Object} e - Update button element clicked
         */
        update: function(e) {
            var _e = $(e);
            var dropdown = _e.closest('.dropdown-menu.pr_doc_request_update');
            var pr_doc_reminder = _e.data('pr_doc_reminder')
            var interval = dropdown.find('input.pr_doc_reminder_interval');

            axios.put('/api/pr_docs/update/' + pr_doc_reminder,dropdown.find("form").serialize()).then(response => {
                console.log(JSON.stringify(response.data,{},4));
                $(dropdown).dropdown('toggle');
                // NOTE:  We want to refresh the datatable. However, we can only do this by calling
                // prdocs.outstanding() as there is no ajax attribute associated with the datatable
                // object which would otherwise have allowed us to call
                // abcsetup.dashboard.rx_vendor.prdocs.datatable.ajax.reload() - hence, this forces
                // a reload of the entire #pr_doc_items element
                window.location.reload();
            });
        },
    },





    ///////////////////////////////////////////////////////////////////////////////////////////////////
    //
    //  Item Maintenance Methods
    //
    ///////////////////////////////////////////////////////////////////////////////////////////////////
    item_maintenance: {
        /**
         *
         */
        delete: function(id, type) {
            abcsetup.dashboard.showLoading($('#new_items_panel'));
            $('#new_items_panel').find('.dataTables_wrapper').hide();

            var entity_type = 'rx_item';
            if (type == 'OTG') {
                entity_type = 'front_store'
            }

            $.ajax({
                type: "POST",
                url: "/"+entity_type+"/maintenance/"+id+"/cancel",
                cache: false,
                success: function(data) {
                    window.location.reload();
                }
            });
        },
    },





    ///////////////////////////////////////////////////////////////////////////////////////////////////
    //
    //  Frontstore Methods
    //
    ///////////////////////////////////////////////////////////////////////////////////////////////////
    frontstore: {
        /**
         *
         */
        delete: function(id) {
            abcsetup.dashboard.showLoading($('#new_items_panel'));
            $('#new_items_panel').find('.dataTables_wrapper').hide();

            axios.delete('/front_store/' + id).then(response => {
                window.location.reload();
            });
        },
    },




    ///////////////////////////////////////////////////////////////////////////////////////////////////
    //
    //  RFQ Methods
    //
    ///////////////////////////////////////////////////////////////////////////////////////////////////
    rfq: {
        /**
         *
         */
        deleteEvent: function(id) {
            abcsetup.dashboard.showLoading($('#outstanding_panel'));
            $('#outstanding_panel').find('.dataTables_wrapper').hide();

            axios.delete('/rfq/' + id).then(response => {
                abcsetup.dashboard.rx_vendor.rfq.outstanding();
                abcsetup.dashboard.rx_vendor.rfq.library();
            });
        },

        /**
         *
         */
        retractEvent: function(id) {
            abcsetup.dashboard.showLoading($('#rfq_panel'));
            $('#rfq_panel').find('.dataTables_wrapper').hide();

            axios.post('/api/rfq/retract/' + id).then(response => {
                abcsetup.dashboard.rx_vendor.rfq.outstanding();
                abcsetup.dashboard.rx_vendor.rfq.inReview();
                abcsetup.dashboard.rx_vendor.rfq.library();
            });
        },

        /**
         *
         */
        extendEvent: function(id, days) {
            abcsetup.blockUI(true);

            axios.post('/api/rfq/extend', { id: id, days: days})
                .then(response => {
                    abcsetup.unblockUI();
                    
                    if (response.data && response.data.success) {
                        abcsetup.alerts.show('Request an Extension', 'Your extension request has been submitted');
                        window.LaravelDataTables['app_data_tables_r_f_q_bid_request_data_table'].ajax.reload();
                    }
                })
                .catch(error => {
                    console.error(error);
                    abcsetup.unblockUI();
                    abcsetup.alerts.show('Error', 'Something went wrong trying to request an extenions. Please reach out to support.');
                });
        },
    }
}
